import { Injectable } from '@angular/core';
import { NetworkManager } from 'src/app/managers/network/network.manager';
import { HttpHeaders } from '@angular/common/http';
import { RequestField } from 'src/app/enums/network/request/requestField.enum';
import { CQWebappApi } from 'src/app/enums/network/request/cqwebapp/cqwebappApi.enum';
import { MessageDetail } from 'src/app/beans/message/message.detail.bean';

@Injectable({
  providedIn: 'root',
})
export class MessageRequest {
  constructor(private network: NetworkManager) {}

  /**
   *
   * @param token
   * @param siteId
   */
  getList(token: string, siteId: number) {
    let url = this.network.CodaQApi() + CQWebappApi.MESSAGE_LIST;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.SITE_ID, siteId.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param siteId
   * @param messageId
   */
  getDetail(token: string, siteId: number, messageId: number) {
    let url = this.network.CodaQApi() + CQWebappApi.MESSAGE_DETAIL;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.SITE_ID, siteId.toString());
    form.set(RequestField.MESSAGE_ID, messageId.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param siteId
   * @param data
   */
  create(token: string, siteId: number, data: MessageDetail) {
    let url = this.network.CodaQApi() + CQWebappApi.MESSAGE_CREATE;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.SITE_ID, siteId.toString());
    form.set(RequestField.MESSAGE_DATA, JSON.stringify(data));

    return this.network.http().post(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param messageId
   * @param data
   */
  update(token: string, siteId: number, messageId: number, data: string) {
    let url = this.network.CodaQApi() + CQWebappApi.MESSAGE_UPDATE;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.SITE_ID, siteId.toString());
    form.set(RequestField.MESSAGE_ID, messageId.toString());
    form.set(RequestField.MESSAGE_DATA, data.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param siteId
   * @param messageId
   */
  delete(token: string, siteId: number, messageId: number) {
    let url = this.network.CodaQApi() + CQWebappApi.MESSAGE_DELETE;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.SITE_ID, siteId.toString());
    form.set(RequestField.MESSAGE_ID, messageId.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }
}
